import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as SetMarketingStatusActionMetadataKeys from 'automation-ui-action-features/deprecated/set-marketing-status/SetMarketingStatusActionMetadataKeys';
import * as marketingTypeConstants from 'automation-ui-action-features/deprecated/set-marketing-status/marketingTypeConstants';
/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export default class SetMarketingStatusActionMetadata extends Record({
  [SetMarketingStatusActionMetadataKeys.ACTION_TYPE]: ActionTypes.SET_MARKETING_STATUS,
  [SetMarketingStatusActionMetadataKeys.MARKETABLE_TYPE]: marketingTypeConstants.MARKETABLE
}, 'SetMarketingStatusActionMetadata') {}